import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';

import {
  ContactUsScreen,
  TrackFeedbackFormScreen,
  TrackFeedbackScreen,
  CreditsPaymentScreen,
} from '@screens';
import { screens } from './screens';
import type { FeedbackStackParamListType } from './types';
import { Header, WebHeader } from '@components';

const FeedbackStack =
  createNativeStackNavigator<FeedbackStackParamListType>();

export const FeedbackNavigator = observer(() => {
  return (
    <FeedbackStack.Navigator
      screenOptions={{
        headerShown: true,
        header: (props) =>
          Platform.select({
            web: <WebHeader activeTabButtonName={screens.MyMusic} />,
            default: <Header {...props} />,
          }),
      }}
    >
      <FeedbackStack.Screen
        component={TrackFeedbackScreen}
        name={screens.TrackFeedback}
      />

      <FeedbackStack.Screen
        component={TrackFeedbackFormScreen}
        name={screens.TrackFeedbackForm}
      />
      <FeedbackStack.Screen
        component={ContactUsScreen}
        name={screens.ContactUs}
      />
      <FeedbackStack.Screen
        component={CreditsPaymentScreen}
        name={screens.CreditsPayment}
      />
    </FeedbackStack.Navigator>
  );
});
